<template>

  <div class="conmain">
    <el-input placeholder="题目或课程名称"  v-model="search_value" @keyup.enter.native="search_click()"  prefix-icon="el-icon-search"   style="width: 20%; " ></el-input>
    <el-table stripe :data="subject_list.data"
      style="width: 100%">
      <el-table-column label="类型" sortable width="100">
       <template slot-scope="scope">
          <p v-if="scope.row.type=='0'">选择</p>
          <p v-if="scope.row.type=='2'">判断</p>
        </template>
      </el-table-column>
      <el-table-column label="题目" prop="name"  sortable>
      </el-table-column>
      <el-table-column label="所属" prop="t_all"  width="100" sortable>
      </el-table-column>
      <el-table-column label="级别" sortable width="100">
        <template slot-scope="scope">
           <p v-if="scope.row.level=='0'">简单</p>
           <p v-if="scope.row.level=='1'">中等</p>
           <p v-if="scope.row.level=='2'">困难</p>
         </template>
      </el-table-column>
      <el-table-column label="操作" sortable width="100">
        <template slot-scope="scope">
           <el-button type="text" size="small" icon="el-icon-view" @click="watch(scope.row)"></el-button>
         </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="subject_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="subject_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="subject_list.total">
      </el-pagination>
    </div>
    <el-dialog title="详情 ":visible.sync="watch_subject.status">
      <el-form>
        <el-form-item label="题干:">

          <el-row>{{watch_subject.info.name}}</el-row>
        </el-form-item>
        <el-form-item label="题型:">
          <el-row>
             <el-row v-if="watch_subject.info.type=='0'">选择</el-row>
             <el-row v-if="watch_subject.info.type=='2'">判断</el-row>
          </el-row>

        </el-form-item>
        <el-form-item label="难易度:" >
          <el-row>
          <el-row v-if="watch_subject.info.level=='0'">简单</el-row>
          <el-row v-if="watch_subject.info.level=='1'">中等</el-row>
          <el-row v-if="watch_subject.info.level=='2'">困难</el-row>
          </el-row>

        </el-form-item>
        <el-form-item label="选项:" v-if="watch_subject.info.choice_status">
          <el-row>{{watch_subject.info.choice}}</el-row>
        </el-form-item>
        <el-form-item label="答案:" >
          <el-row>{{watch_subject.info.answer}}</el-row>
        </el-form-item>
        <el-form-item label="解析:" >
          <el-row>{{watch_subject.info.info}}</el-row>
        </el-form-item>
        <el-form-item label="反馈:" v-if="this.$store.state.info.company.name=='北京睿知而行科技有限公司'"  >
          <el-row>
            <el-input  type="textarea" v-model="feedback_input" placeholder="题干改为XXXXXXX,选项改为XXXXXX" style="width: 85%;"></el-input>
            <el-button @click="feedback_click(watch_subject.info)" size="mini" style="float: right;  margin-top: 1.25rem;"  type="primary">反 馈</el-button>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="watch_subject.status = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        feedback_input:'',
        search_value:'',
        subject_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        watch_subject:{
          status:false,
          info:{}
        }
      }

    },
    components: {},
    mounted:function(){
      this.get_subject();
    },

    methods: {
      feedback_click(item){
        let _this=this
        let data={
          num:item.num,
          content:_this.feedback_input
        }
        _this.axios.post('/v2/c_resource/subject_question',{data:data}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.feedback_input=''
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      search_click(){
        this.get_subject()
      },
      get_subject(){
        let _this=this;
        _this.axios.get('/v2/c_resource/get_subject_list',{params:{'page':_this.subject_list.current_page,'limit':_this.subject_list.per_page,'type':'0','keyword':_this.search_value}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              let a=[]
              _this.subject_list=res.data.data
              _this.subject_list.per_page=parseInt(_this.subject_list.per_page)
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleSizeChange(val) {
        this.subject_list.current_page = 1;
        this.subject_list.per_page = val;
        this.get_subject();
      },
      handleCurrentChange(val) {
        let _this=this
        _this.subject_list.current_page = val;
        _this.get_subject();
      },
      watch(data){
        this.watch_subject.info.name=data.name
        this.watch_subject.info.num=data.num
        this.watch_subject.info.type=data.type
        this.watch_subject.info.level=data.level
        this.watch_subject.info.answer=data.answer
        this.watch_subject.info.info=data.info
        this.watch_subject.info.choice_status=false
        this.watch_subject.info.choice=''
        if(data.type=='0'){
            this.watch_subject.info.choice_status=true
            var choice=data.choice.split('----')
            for(var i=0;i<choice.length;i++){
                this.watch_subject.info.choice+=String.fromCharCode(65+i)+'.'+choice[i]
            }
        }
        if(data.type=='2'){
          if(data.answer=='0'){
            this.watch_subject.info.answer='错误'
          }else{
            this.watch_subject.info.answer='正确'
          }
        }
        this.watch_subject.status=true
      }

    }
  }
</script>

<style scoped>
  .conmain {
    width: 100%;
    height: 100%;
  }
  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/course/YzCourse/Subject.vue